export default {"src":"/_next/static/media/logo-with-text.45ff0eb5.svg","height":190,"width":402};